import * as React from 'react';
import styled from "styled-components";

const SLang = styled.div`
  flex: 1; /* Allows main content to take up the remaining horizontal space */
  padding: 5px 30px;
  td {
    padding: 5px;
  }
`;

const Lang = () => {
  return (
    <SLang>
      <h5>O języku</h5>

<p><b>Język hiszpański</b> jest jednym z najbardziej rozpowszechnionych języków świata.
Jako języka ojczystego używa go ponad 250 milionów ludzi (m.in. w Hiszpanii -
28 mln, w Meksyku i Ameryce Środkowej i Południowej - 90 mln i w USA - 22,4 mln).
 Hiszpański jest jednym z oficjalnych języków ONZ, Unii Afrykańskiej oraz
 Europejskiej. Pod względem pochodzenia jest to język romański, bardzo blisko
 spokrewniony z pozostałymi językami Półwyspu Iberyjskiego - portugalskim,
 galicyjskim i katalońskim. Wśród języków wywodzących się z łaciny ludowej
 hiszpański jest jednym z bardziej archaicznych. Stało się tak dlatego, iż od
 wieku XII ewoluował on bardzo powoli i stosunkowo niewiele się zmienił.</p>

<p>Przed podbojem Półwyspu Iberyjskiego przez Rzymian, który nastąpił w II wieku
p.n.e., dzisiejszą Hiszpanię zamieszkiwały rozmaite plemiona: Iberowie, Celtowie,
Baskowie, Grecy, Kartageńczycy, Fenicjanie. W ciągu pierwszych dwustu lat panowania
rzymskiego wszystkie miejscowe języki (z wyjątkiem baskijskiego w zachodnich
Pirenejach) ustąpiły miejsca łacinie, która dała w ten sposób początek współczesnemu
językowi hiszpańskiemu. Po upadku Cesarstwa Rzymskiego tereny Hiszpanii opanowane
zostały przez Wizygotów, a następnie - w roku 711 - przez Arabów. Panowanie arabskie
trwało na całości lub części Półwyspu Iberyjskiego przez ponad 700 lat, do roku 1492.
W tym okresie język arabski wywarł ogromny wpływ na słownictwo hiszpańskie, do
którego weszło około trzech tysięcy arabskich wyrazów.</p>

<p>Pierwszy znany dłuższy tekst w języku hiszpańskim to spisana w 1307 roku, a
powstała kilkadziesiąt lat wcześniej pieśń "Centar del mio Cid". Jednakże jeżeli
uwzględni się pisane alfabetem arabskim w dialekcie mozarabskim krótkie utwory
liryczne zwane jerchas, należy datować pierwsze teksty hiszpańskie a za razem
początek literatury w tym języku, na rok 1040.</p>

<p>Do XV wieku język hiszpański rozwijał się wyłącznie na kontynencie europejskim,
ale w epoce wielkich wypraw i odkryć geograficznych rozprzestrzenił się bardzo
szybko na ogromnych obszarach Ameryki południowej i Środkowej. Hiszpański używany
w Ameryce Łacińskiej w swojej formie literackiej nie odbiega prawie wcale (mimo
150 lat odrębnego rozwoju) od hiszpańszczyzny europejskiej. Natomiast język
mówiony krajów tego obszaru wywodzi się przede wszystkim z dialektu
andaluzyjskiego (a nie kastylijskiego), stąd pewne różnice, szczególnie w
zakresie wymowy, między hiszpańszczyzną europejską a amerykańską (też zresztą
dość wewnętrznie zróżnicowaną). Nie zmienia to faktu, że hiszpański zachowuje i
tak bardzo dużą jednolitość i ma tylko jedną formę literacką.</p>

<p>Podstawą współczesnego hiszpańskiego języka literackiego jest dialekt
kastylijski (stąd hiszpański bywa nazywany kastylijskim), którego kolebką była
Stara Kastylia, na północy Półwyspu Iberyjskiego, i stąd rozpowszechnił się on
w ciągu wieków, wypierając stopniowo inne dialekty hiszpańskie jak asturyjski,
nawarro-aragoński, leoński czy martwy już dziś mozarabski. Konstytucja
Hiszpanii stanowi, że językiem urzędowym w całym państwie jest właśnie język
kastylijski. W niektórych regionach status języka urzędowego ma również lokalny,
rodzimy język:
<li>baskijski w Kraju Basków i Nawarze</li>
<li>kataloński w Katalonii, Walencji i na Balearach</li>
<li>galicyjski w Galicji</li>
<li>oksytański w Val d'Aran w Katalonii.</li>
</p>

<p><b>Język kastylijski</b> - historyczna nazwa języka hiszpańskiego,
wywodząca się od nazwy hiszpańskiego królestwa Kastylii. W przeszłości jego
odmiana północnokastylijska była uznawana przez Real Academia Española za
obowiązujący wzorzec języka urzędowego w Hiszpanii i innych krajach
hiszpańskojęzycznych. Podczas gdy większość Hiszpanów (= mieszkańców Hiszpanii)
nazywa swój język ojczysty <b><i>español</i></b> (= hiszpański), to mieszkańcy Meksyku,
Ameryki Środkowej czy Południowej mówią o swoim języku <b><i>castellano</i></b>
(= kastylijski), ponieważ nazwa <i>español</i> odnoszona jest jedynie do Hiszpanów.
Podobnie w samej Hiszpanii, nie-hiszpańskojęzyczni jej mieszkańcy mówiąc o
hiszpańskim użyją raczej nazwy <i>castellano</i>. Jest to poniekąd wyrazem ich
sprzeciwu wobec przenoszenia nazwy tego języka regionalnego Hiszpanii (choć
najbardziej rozpowszechnionego) na nazwę języka całego kraju, co jest
odbierane przez nich jako działanie skierowane przeciwko ich językom.</p>

<p><b>Język baskijski</b> (bask. <i>euskara</i>) - język Basków zamieszkujących kilka
prowincji na pograniczu Hiszpanii i Francji. Posługuje się nim dzisiaj ponad
milion górali pirenejskich (90% w Hiszpanii). Jego przynależność genetyczna
nie została do tej pory ustalona, ale z pewnością nie jest to język
indoeuropejski, i pochodzi on od języków, którymi mówiono przed kolonizacją
zachodniej Europy przez Indoeuropejczyków. Istnieją także przypuszczenia, że
jest on spokrewniony z językami kaukaskimi. W języku baskijskim występują
liczne zapożyczenia z łaciny, hiszpańskiego i francuskiego. Wyróżnia się 10
dialektów języka baskijskiego. Ze względu na duże różnice pomiędzy nimi
powstała ustandaryzowana odmiana języka - Euskara batua, łącząca cechy
największych dialektów języka baskijskiego, oparta zwłaszcza na dialekcie
Gipuzkoa. Odmiana ta nauczana jest w szkołach. Pod względem gramatycznym
baskijski jest językiem ergatywnym. Literatura w tym języku powstaje od XVI
wieku. Pierwszą drukowaną książkę w tym języku wydano w 1545 roku.<br/>
Przykłady:
<li>Dziękuję - Eskerrik asko</li>
<li>Nie - Ez</li>
<li>Tak - Bai</li>
<li>Proszę - Mesedez</li>
<li>Cześć - Kaixo</li>
<li>Dzień dobry - Egunon</li>
<li>Czy mówisz po baskijsku? - Euskera badakizu?</li>
<li>Jak leci? - Zelan zagoz?</li>
<li>Świetnie - Ondo</li>
<li>Cieszę się - Poztuten naz</li>
</p>

<p><b>Język kataloński</b> (Català) to język należący do grupy
romańskiej języków indoeuropejskich. Posługuje się nim ok. 7 mln osób
przede wszystkim w Hiszpanii, ale także w południowej Francji (rejon
Roussillon zwany Północną Katalonią) i we Włoszech (okolice miasta Alghero
na Sardynii). Ma status języka urzędowego w Andorze oraz, razem w językiem
hiszpańskim, w niektórych regionach Hiszpanii: Katalonii, Walencji i na
Balearach. Dzieli się na dwa główne dialekty: wschodni (podgrupy: centralna,
północna Rousillon, balearska, algherska) i zachodni (północno-wschodni
Ribagorçà i walencki). Kataloński jako język literacki uformował się w
XV wieku, choć pierwsze teksty w nim zapisane powstawały już na przełomie
XII i XIII wieku. Po okresie dominacji języka hiszpańskiego (kastylijskiego)
kataloński przeżył okres rozkwitu na początku XX wieku, któremu kres
położyła hiszpańska wojna domowa. W czasie dyktatury generała Franco
używanie języka katalońskiego w miejscach publicznych było prawnie
zakazane. Obecnie jest on wystandardyzowanym językiem używanym we
wszystkich sferach życia.</p>

<p><b>Język galicyjski</b> (gal. <i>galego</i>, hiszp. <i>gallego</i>,
port. <i>galego</i>) - język z grupy romańskiej języków indoeuropejskich,
którym posługuje się ok. 3,2 mln Galicyjczyków zamieszkujących głównie
hiszpański region autonomiczny Galicję (język urzędowy wraz z kastylijskim)
oraz sąsiednie prowincje Asturia, León i Zamora. Podtrzymywany jest także
wśród wspólnot emigracyjnych Galicyjczyków w Argentynie, Brazylii i Meksyku.
Zdaniem niektórych językoznawców galicyjski, portugalski i mirandyjski to
trzy odmiany tego samego języka. Galicyjski powstał w wyniku nałożenia się
na pierwotne języki iberoceltyckie prowincjonalnej łaciny, a potem zasilenia
tego obszaru językowego przez języki germańskich Swewów i Wizygotów, a także
napływających wtórnie z Brytanii Celtów i oczywiście Arabów w czasie ich
krótkotrwałego tam panowania. Współczesny galicyjski jest mocno
zhispanizowany. Od wieku XII do XIV stanowił rodzaj języka literackiego dla
całej chrześcijańskiej części Półwyspu Iberyjskiego. Był uznawany za język
ludzi wykształconych. Swoje poematy tworzył w nim m. in. król Alfons X Mądry
(Cantigas de Santa María). O literaturze tamtego okresu mówi się <i>liryka
galicyjsko-portugalska</i> (hiszp. <i>lirica gallego-portuguesa</i>). W średniowieczu
w wyniku zmian politycznych (odłączenie się hrabstwa Portucale od Galicii)
wyodrębnił się z niego - by dalej rozwijać się już samodzielnie - język
portugalski. Co ciekawe język portugalski uznawany jest za bardziej
archaiczny od swego przodka.</p>

<p><b>Język prowansalski</b> (<i>langue d'oc</i>, <b>oksytański</b>,
<i>okcytański</i>) - język z grupy romańskiej języków indoeuropejskich.
Obejmuje szereg zróżnicowanych dialektów, wywodzących się ze średniowiecznego
języka <i>langue d'oc</i> i używanych w południowej Francji, a także na
zachodnich obrzeżach włoskiego Piemontu oraz w hiszpańskich Pirenejach.
Dialekty te dzieli się na trzy grupy: północną, południową (w tym dialekty
langwedockie i prowansalskie) oraz gaskońską. Brakuje oficjalnych danych
na temat liczby ich użytkowników, szacunki są bardzo rozbieżne.
Prawdopodobnie około miliona osób zna któryś z oksytańskich dialektów na
tyle dobrze, by posługiwać się nim w życiu codziennym. Obecnie nie ma
powszechnie akceptowanego standardu prowansalskiego języka literackiego.
Najpoważniejszymi kandydatami do tego tytułu są język oparty na dialektach
prowansalskich, którego używał poeta Frédéric Mistral, oraz standard oparty
na dialektach langwedockich, uważanych za "najczystszą" odmianę języka
oksytańskiego. Wśród dialektów oksytańskich szczególny status ma gwara
<i>aranés</i>, która jest jednym z trzech języków urzędowych w należącej
do Hiszpanii dolinie Val d'Aran (obok hiszpańskiego i katalońskiego).
Posługuje się nią ok. 4 tys. osób. Język oksytański jest blisko
spokrewniony z językiem katalońskim. Niekiedy bywa uznawany za dialekt
języka francuskiego, jednak nie jest to uzasadnione z historycznego i
lingwistycznego punktu widzenia.</p>

<p><b>Spanglish</b> (czyt. [spanglisz] lub [spanglis]) - utworzony
na bazie meksykańskiej odmiany hiszpańskiego i amerykańskiej odmiany
angielskiego. Rozpowszechniony zwłaszcza na pograniczu meksykańsko-amerykańskim
oraz w rejonach większych skupisk ludności pochodzenia latynoskiego.
Charakteryzuje się uproszczoną gramatyką hiszpańską i olbrzymią ilością
zapożyczeń, zwłaszcza leksykalnych, z języka angielskiego. Na początku
był jedynie językiem ulicy, tej gorzej wykształconej i biedniejszej, w
miarę zyskiwania popularności wśród Latynosów, ze szkół, knajp i domów
wszedł do muzyki, sztuki, mediów.<br/>
Przykłady:
<table width="100%">
<tr><td width="15%"><b>j. polski</b></td><td width="15%"><b>spanglish</b></td><td width="15%"><b>hiszpański</b></td>
<td width="15%"><b>angielski</b></td><td><b>przykład</b></td></tr>
<tr><td>bezpieczeństwo</td><td>safety</td><td>seguridad</td><td>safety</td>
<td>La marketa deberia tener mas safeties; pues fue robada ayer.</td></tr>
<tr><td>biblioteka</td><td>libreria</td><td>library</td><td>biblioteca</td>
<td>Voy a ir a la libreria a estudiar un poco mas de spanglish.</td></tr>
<tr><td>bilet</td><td>ticket</td><td>boleto o infraccion</td><td>ticket</td>
<td>Tengo un ticket para las movies.... l`a chota me dio un ticket por manejar muy recio</td></tr>
<tr><td>blok (budynek)</td><td>blokes</td><td>cuadra</td><td>block</td>
<td>La marketa esta como a unos cinco blokes de aqui.</td></tr>
<tr><td>być nieobecnym (opuszczać)</td><td>eskipear</td><td>salarsela o faltar a clase</td><td>skip</td>
<td>Maria se eskipea de la High School cada semana para irse con su novio.</td></tr>
<tr><td>ćwiartka (o pieniądzu-drobne)</td><td>cora</td><td>cuarto</td><td>quarter</td>
<td>Quarter se refiere a un cuarto del dolar;no tienes unas coras para llamar por telefono?</td></tr>
<tr><td>ćwiczyć</td><td>training</td><td>entrenar</td><td>training</td>
<td>Jose tiene que estar bien trainiado para su try-out.</td></tr>
<tr><td>dach</td><td>ruffo</td><td>techo</td><td>roof</td>
<td>Oh! mira, el gato esta en el ruffo!</td></tr>
<tr><td>dystrybutor</td><td>dealer</td><td>distribuidor</td><td>dealer</td>
<td>Ayer fui al dealer de carros para comprarme un carro nuevo.</td></tr>
<tr><td>dywan</td><td>carpeta</td><td>alfombra</td><td>carpet</td>
<td>Tengo que limpiar la carpeta con la aspiradora.</td></tr>
<tr><td>dziecko</td><td>baby</td><td>bebe</td><td>baby</td>
<td>Maria recientemente tuvo un baby, y esta bien cute!.</td></tr>
<tr><td>dziesięciocentówka</td><td>dime</td><td>10 centavos</td><td>dime</td>
<td>Hey, ese no tienes un dime que me prestes?</td></tr>
<tr><td>film</td><td>movies</td><td>pelicula</td><td>movie</td>
<td>Anoche fui a watchar las movies con mi novia.</td></tr>
<tr><td>gang</td><td>ganga</td><td>pandilla</td><td>gang</td>
<td>Maria perteneze a la ganga de sur de L.A.</td></tr>
<tr><td>gotować</td><td>cuquear</td><td>cocinar</td><td>cook</td>
<td>Honey, apurate a cuquear la comida que ya tengo hambre.</td></tr>
<tr><td>hamburger z serem</td><td>cheeseburger</td><td> hamburgesa de queso</td><td>cheeseburger</td>
<td>Quiero una cheeseburger, fries y una soda por favor!</td></tr>
<tr><td>hamulce</td><td>breaks</td><td>frenos</td><td>brakes</td>
<td>Jose tiene que arreglar las brekas de su carro.</td></tr>
<tr><td>kaseta video</td><td>vcr</td><td>videocasetera</td><td>vcr</td>
<td>Jose esta viendo una movie con su vcr.</td></tr>
<tr><td>kasować</td><td>ponchar</td><td>perforar</td><td>punch</td>
<td>Necesito ponchar la tarjeta de horario del trabajo todos los dias</td></tr>
<tr><td>każdy inny dzień</td><td>cada otro dia</td><td>cada tercer dia</td><td>every other day</td>
<td>Yo voy al gym cada otro dia para pumpear mis musculos.</td></tr>
<tr><td>klikać</td><td>clikear</td><td>oprimir</td><td>click</td>
<td>Haz click aqui para visitar mi website.</td></tr>
<tr><td>kod kreskowy</td><td>zip code</td><td>codigo postal</td><td>zip code</td>
<td>Asegurate de poner el zip code en la carta.</td></tr>
<tr><td>kosz</td><td>ben</td><td>arcon</td><td>bin</td>
<td>Jose tiene que llenar cuatro benes de manzanas en el field.</td></tr>
<tr><td>lancz (drugie śniadanie)</td><td>lonche</td><td>almuerzo</td><td>lunch</td>
<td>Tiene dos significados almuerzo:voy a comprar una cheeseburger para mi lonche".</td></tr>
<tr><td>market</td><td>marketa</td><td>mercado</td><td>market</td>
<td>Mi mama fue a la marketa para comprar el lonche de la semana.</td></tr>
<tr><td>menedżer</td><td>manager</td><td>gerente</td><td>manager</td>
<td>El manager de mi trabajo es una persona negrera.</td></tr>
<tr><td>ochrona</td><td>security</td><td>seguridad</td><td>security</td>
<td>Llamen a un security si tienen algun problema.</td></tr>
<tr><td>oddać (dać z powrotem)</td><td>atras</td><td>regresar</td><td>back</td>
<td>Tengo que dar para atras el libro a la biblioteca.</td></tr>
<tr><td>odkurzać</td><td>vacunar</td><td>aspirer</td><td>vacuum</td>
<td>Mi honey tiene que vacunar la carpeta por que esta muy cochina.</td></tr>
<tr><td>oglądać</td><td>watchar</td><td>observar</td><td>watch</td>
<td>Hey, Jose, watcha por donde caminas, ya mero te caes!</td></tr>
<tr><td>opiekować się</td><td>babysit</td><td>cuidar niños</td><td>babysit</td>
<td>Maria tiene que babysit a su hermanita en la noche.</td></tr>
<tr><td>paliwo</td><td>gasoline</td><td>gasoline</td><td>gasoline</td>
<td>Voy a llenar el tanque de mi carro con gasoline. 	</td></tr>
<tr><td>parking</td><td>parkeaderos</td><td>estacionamientos</td><td>parking lot</td>
<td>Estaciona tu troca en otro lado por que el parkeadero esta lleno.</td></tr>
<tr><td>parkować</td><td>parkear</td><td>estacionar</td><td>park</td>
<td>Hey, Jose; donde parkeaste tu carro que no lo encuentro!</td></tr>
<tr><td>pchać</td><td>puchar</td><td>empujar</td><td>push</td>
<td>Jose, ayudame a puchar el carro pa'delante!</td></tr>
<tr><td>pieniądz gotówkowy</td><td>cash</td><td>dinero en efectivo</td><td>cash</td>
<td>Mi boss me pago con cash por haber trabajado overtime.</td></tr>
<tr><td>pisać na maszynie (klawiaturze)</td><td>taipear</td><td>escribir a maquina</td><td>type</td>
<td>Maria sabe taipear mas de 60 palabras por minuto!</td></tr>
<tr><td>napis (wywieszka)</td><td>sign</td><td>letrero</td><td>sign</td>
<td>Cuando vayas por la calle, busca el sign que dice "Taco Bell".</td></tr>
<tr><td>po godzinach</td><td>overtime</td><td>tiempo extra</td><td>overtime</td>
<td>Jose trabajo overtime la semana pasada.</td></tr>
<tr><td>poczta elektroniczna</td><td>mailear</td><td>enviar correo</td><td>mail</td>
<td>Tengo que mailear una carta a mi novia por e-mail.</td></tr>
<tr><td>podatek dochodowy</td><td>income tax</td><td>impuesto sobre ingreso</td><td>income tax</td>
<td>Ya me canse del gobierno, estoy pagando mucho income tax!</td></tr>
<tr><td>podatki</td><td>taxes</td><td>impuestos</td><td>taxes</td>
<td>La troca cuesta $15000 mas taxes.</td></tr>
<tr><td>podpisywać</td><td>signear</td><td>firmar</td><td>sign</td>
<td>Boss, si puede signear mi check.</td></tr>
<tr><td>podwórko (ogródek)</td><td>yarda</td><td>patio o solar</td><td>yard</td>
<td>Vieja! manda a los ninos a jugar a la yarda!</td></tr>
<tr><td>pole uprawne</td><td>field</td><td>campo</td><td>field</td>
<td>Jose trabaja en el field de manzanas cada año.</td></tr>
<tr><td>pompować</td><td>pompear</td><td>bombear</td><td>pump</td>
<td>Tengo que pompear la llanta del carro, pues se poncho.</td></tr>
<tr><td>porzucić (zostawić)</td><td>quitear</td><td>dejar</td><td>quit</td>
<td>Ya me canze de mi trabajo!!, voy a quitear mañana mismo!!</td></tr>
<tr><td>pralnia</td><td>washateria</td><td>lavanderia</td><td>laundry</td>
<td>Voy a la washateria a lavar la ropa.</td></tr>
<tr><td>przekaz pieniężny</td><td>money order</td><td>giro posta</td><td>money order</td>
<td>Ayer le mande un money order a mi madre a Mexico.</td></tr>
<tr><td>przerwa</td><td>break</td><td>dezcanso</td><td>break</td>
<td>Estoy muy canzado de trabajar, hay que tomar un break, no?</td></tr>
<tr><td>przyciąć</td><td>apodar</td><td>podar</td><td>prune</td>
<td>Se usa mucho entre los trabajadores del campo "yo trabajo apodando los arboles de manzana".</td></tr>
<tr><td>przystawka (przed obiadem)</td><td>startear</td><td>prender</td><td>start</td>
<td>Honey, podrias startear el carro please?</td></tr>
<tr><td>rachunek</td><td>bill</td><td>cobro</td><td>bill</td>
<td>Maria va a pagar todos los biles de la renta, etc.</td></tr>
<tr><td>kochanie (pieszczotliwe określenie osoby)</td><td>honey</td><td>querida</td><td>honey</td>
<td>Hey, honey, ya tienes la cena lista?</td></tr>
<tr><td>skarpetki</td><td>socketines</td><td>calcenites</td><td>socks</td>
<td>Tuve que lavar mis socketines por que no tenia ni uno limpio cada verano.</td></tr>
<tr><td>sklep spożywczy</td><td>groceria</td><td>alimentos</td><td>grocery</td>
<td>Tengo que ir a la marketa a comprar groceries.</td></tr>
<tr><td>spodnie dżinsowe</td><td>jeans</td><td>pantalones (de dril)</td><td>jeans</td>
<td>Compre un par de jeans en la mall, estan bien cool!</td></tr>
<tr><td>spotkanie</td><td>appointment</td><td>cita</td><td>appointment</td>
<td>"Maria tiene que ir al doctor, pues tiene un appoinment a las 3:00.</td></tr>
<tr><td>sprawdzić</td><td>chequear</td><td>examiner</td><td>check</td>
<td>Maria va a chequear al baby que va a babysit por la noche.</td></tr>
<tr><td>sprzedawać</td><td>sale</td><td>venta</td><td>sale</td>
<td>Manana vamos ir shopping, pues hay un sale en el mall.</td></tr>
<tr><td>stłuczka</td><td>bombe</td><td>tope</td><td>bump</td>
<td>Cuidado con ese bompe en la calle!</td></tr>
<tr><td>strażnik leśny</td><td>ranger</td><td>guardabosques</td><td>ranger</td>
<td>Cuando vamos de cazeria, tenemos que cuidarnos del ranger.</td></tr>
<tr><td>szafka (schowek)</td><td>locker</td><td>cacillero</td><td>locker</td>
<td>Esperame, Maria!! tengo que ir a mi locker a tomar unos libros!</td></tr>
<tr><td>szklanka</td><td>glasso</td><td>vaso</td><td>glass</td>
<td>Todas las noches, mi baby toma un glasso de leche</td></tr>
<tr><td>światła uliczne</td><td>luz</td><td>semaforo</td><td>traffic light</td>
<td>El policia me dio un ticket for pasarme una luz roja!</td></tr>
<tr><td>taca</td><td>tray</td><td>bandeja</td><td>tray</td>
<td>Trabajo en una empacadora, llenando trays de manzana.</td></tr>
<tr><td>ubezpieczenie</td><td>aseguranza</td><td>seguro</td><td>insurance</td>
<td>"Miguel tiene que obtener una aseguranza para su automobil"</td></tr>
<tr><td>umowa (oferta)</td><td>deal</td><td>trato</td><td>deal</td>
<td>Cuando fui a comprar un carro en el dealer, el salesman me ofrecio un deal muy bueno.</td></tr>
<tr><td>wiadomość elektroniczna</td><td>e-mail</td><td>mensaje</td><td>e-mail</td>
<td>Si conoces otra palabra spanglish mandame un e-mail.</td></tr>
<tr><td>wiśnia</td><td>cherry</td><td>cereza</td><td>cherry</td>
<td>Todos los veranos trabajo sorteando cherries en una empacadora.</td></tr>
<tr><td>woda sodowa</td><td>soda</td><td>refresco</td><td>soda</td>
<td>Que calor! vamos a comprar una soda</td></tr>
<tr><td>wyciek (wyciekać)</td><td>likear</td><td>gotear</td><td>leak</td>
<td>La llave del agua estaba likeando toda la noche!</td></tr>
<tr><td>wymawiać</td><td>spelear</td><td>deletrear</td><td>spell</td>
<td>Es que no se como espelearle mi nombre.</td></tr>
<tr><td>występ</td><td>show</td><td>espectaculo</td><td>show</td>
<td>El show de Jim Carrey estuvo chingon!</td></tr>
<tr><td>zabawa</td><td>party</td><td>fiesta</td><td>party</td>
<td>Jose y maria van esta invidados a un party.</td></tr>
<tr><td>zakupy</td><td>shopping</td><td>compras</td><td>shopping</td>
<td>A las chicas les encanta ir shopping a la mall.</td></tr>
<tr><td>zamrażarka</td><td>freezer</td><td>congelador</td><td>freezer</td>
<td>El lonche esta almacenado en el freezer.</td></tr>
<tr><td>zapis</td><td>transcript</td><td>constancia de estudios</td><td>transcript</td>
<td>Obtuve un transcript cuando me gradue de High School.</td></tr>
<tr><td>zlewozmywak</td><td>sink</td><td>fregadero</td><td>sink</td>
<td>Jose, pon los platos en el sink!</td></tr>
</table></p>
    </SLang>
  )
};

export default Lang;